.doctorInfo {
  margin: 0;
  padding: 0;
}

.doctorInfoItem {
  list-style-type: none;
}
